<script>

    export let config;
    export let contentID;

    $ : files = loadFiles(contentID);

    function loadFiles(content) {
        return fetch(config.model_root + 'shared/files/load_files.php?c=' + content + '&t=file', {
            method: "GET"
        })
            .then(response => response.json());
    }

</script>

<div class="my-5">

    {#await files}
        <p class="link-dark text-dark d-block my-2 px-3 py-2 mt-2 rounded downloads">
            <i class="fas fa-circle-notch fa-spin"></i> Anhänge werden geladen...
        </p>
    {:then items}

        {#if items.length > 0}

            {#each items as file}

                <a href="{config.application_root}files/{file.fpath}" target="_blank" class="link-dark text-dark d-block mx-auto my-2 px-4 py-3 mt-4 rounded downloads text-decoration-none">
                    <i class="fas fa-external-link-alt me-2"></i> {@html file.fname}
                </a>

            {/each}

        {/if}

    {:catch error}
        <p style="color: red">{error.message}</p>
    {/await}

</div>

<style>
    .downloads {
        background-color: #dee2e6;
        width: 100%;
        min-width: 300px;
        max-width: 600px;
        transition: all 0.2s ease-out;
        font-size: 24px;
        text-align: center;
    }
    .downloads:hover {
        background-color: #333;
        color: #fff !important;
    }
</style>
